module.exports = __webpack_public_path__ + "img/IMG_Phone_2.97c63fc9.jpg";